import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../core/config.service';
import { Injectable } from '@angular/core';

@Injectable()
export class TestPageService {

  constructor(private configService: ConfigService,
              private httpClient: HttpClient) {
  }

  checkPort443Https() {
    const url = this.configService.getDashBoardHealthUrl() + '/dashboard-health';
    return this.httpClient.get(url).toPromise();
  }


  checkPort80Http(): any {
    const url = 'http://glenn-api.sensorflow.org/dashboard-health/glenn/dashboard-health';
    return this.httpClient.get(url).toPromise();
    // return this.httpClient.getObject(url).toPromise();

  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/test-page/test-page.service.ts